import Vue from 'vue';
import App from './components/App.vue';
import store from './store';
import router from './router';

import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi);

//Общие стили
import './styles';

//Общая часть библиотеки devextreme
import './devextreme';

//Тему devextreme вынесена отдельно
import './styles/dx.generic.core-scheme.css';

//Стили анимации wowjs
import 'wowjs/css/libs/animate.css';

//Регистрация компонентов
import './componentsRegistrationAsync';

Vue.config.productionTip = false;

//Плагин для локализации
import i18n from '@/i18n';

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
